import { render, staticRenderFns } from "./ListProducts.vue?vue&type=template&id=68d2ff3b&scoped=true&"
import script from "./ListProducts.vue?vue&type=script&lang=js&"
export * from "./ListProducts.vue?vue&type=script&lang=js&"
import style0 from "./ListProducts.vue?vue&type=style&index=0&id=68d2ff3b&prod&lang=scss&"
import style1 from "./ListProducts.vue?vue&type=style&index=1&id=68d2ff3b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d2ff3b",
  null
  
)

export default component.exports